<div class="container">
  <div class="content-div">
    <div class="panel left-panel">
      <img 
        src="/assets/images/biq/left-panel.svg" 
        alt="left-panel" 
        class="panel-img left-img"
      />
    </div>
    <div class="info-div">
      <div class="main-div">
        <div class="biq-content-div">
          <img 
            src='/assets/icons/circle-check-big.svg' 
            alt="check"
            class="tick-icon"
          />
          <div class="profile-div">
            <p class="heading">Your profile is set!</p>
            <p class="description">
              Next up: 
              <strong>take the Career Interest Survey</strong> 
              to start getting personalized career matches. 
            </p>
            <app-biq-button (buttonEmitter)="onClickBtn()"></app-biq-button>
          </div>
        </div>
      </div>
    </div>
    <div class="panel right-panel">
      <img 
        src="/assets/images/biq/right-panel.svg" 
        alt="left-panel" 
        class="panel-img right-img"
      />
    </div>
  </div>
</div>
